import queryString from 'query-string';

import { saveTemporaryStorageAndGenerateRedirectURL } from 'utils/temporaryStorage';

type Args = {
  provider: 'facebook' | 'google' | 'apple';
  redirectTo: string | null | undefined;
  inviteId?: string | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  savedListing: Record<string, any> | null | undefined;
  subscribedSubsite: string | null | undefined;
};

export async function getThirdPartyLoginUrl({
  provider,
  redirectTo,
  inviteId,
  savedListing,
  subscribedSubsite,
}: Args) {
  const queryParams = {};
  // @ts-expect-error TS(2339): Property 'provider' does not exist on type '{}'.
  queryParams.provider = provider;

  if (inviteId) {
    // @ts-expect-error TS(2339): Property 'invite' does not exist on type '{}'.
    queryParams.invite = inviteId;
  }

  if (savedListing || subscribedSubsite) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-param-reassign
    redirectTo = await saveTemporaryStorageAndGenerateRedirectURL(redirectTo, {
      // @ts-expect-error TS(2322): Type 'Record<string, any> | null | undefined' is n... Remove this comment to see the full error message
      listing: savedListing,
      subscribedSubsiteId: subscribedSubsite,
    });
  }

  if (redirectTo) {
    // @ts-expect-error TS(2339): Property 'to' does not exist on type '{}'.
    queryParams.to = redirectTo;
  }

  return `/third-party-login?${queryString.stringify(queryParams)}`;
}
